<template>
  <div class="forget-password">
    <div class="title">فراموشی رمز عبور</div>
    <p class="text-info">آدرس ایمیلی که با آن ثبت نام کردید را وارد کنید</p>
    <custom-input type="email" placeholder="ایمیل" auth="auth" :emaillogo="true" @getValue="setMail"/>
    <button @click="submition" class="blue-btn"> تایید</button>
  </div>
</template>

<script>
import CustomInput from "../tools/custom-input";
export default {
  name: "forget-password",
  components: {CustomInput},
  data() {
    return {
    email:''
    };
  },
  methods:{
    async  checkMail(){
      if(!this.$validEmail(this.email) || !this.email){
        this.emailError = 'ایمیل صحیح وارد نمایید'
        this.$error('مقادیر اشتباه','ایمیل وارد شده صحیح نیست','','','','2500')
        return Promise.reject('repeat failed : ' + this.email)
      }
      else return this.emailError = ''

    },

    async setMail(value){
      this.email = value
    },


    async submition(){
      this.checkMail()
      if(!this.emailError){
        const res = await this.$axios.post('/users/forget-password?email=' + this.email)
        if (res.message === 'code sent successfully.') {
          this.state.userInfo.mobilenumber = res.baseDTO.starTwoStepAuthentication || '';
          this.state.userInfo.towStepAuthenticationType = res.baseDTO.towStepAuthenticationType;
        } else {
          this.state.userInfo.towStepAuthenticationType = 'EMAIL'
        }
        this.state.userInfo.email = this.email
        this.$router.push({name:'ResetPassword'})


      }



    }
  }
}
</script>

<style lang="scss" scoped>
.forget-password {
  display: flex;
  flex-direction: column;
  gap: 30px;
  direction: rtl;
  color: #FBFBFD;
  justify-content: center;
  align-items: center;

  .title{
    font-size: clamp(18px , 2vw , 22px);
    font-weight: bold;
  }

  .text-info{
    font-size: clamp(12px , 2vw , 14px);
    text-align: right;
    width:100%;
  }

  button{
    width: 100%;
  }

  label{
    position: relative;
    width: 100%;
    img{
      position: absolute;
      left: 16px;
      top: 35%;
    }
  }
}
</style>